const jQ = jQuery.noConflict();

class ArchiveSidebar {
    constructor(sidebar = jQ('.archive-sidebar'), content = jQ('.archive-sidebar-content'), scrollContent = jQ('.archive-sidebar-scroll')) {
        this.nav = sidebar;
        this.content = content;
        this.scrollContent = scrollContent;
    }
    init() {
        this.archiveNav();
        this.checkScroll();
    }
    archiveNav() {
        const { nav } = this;
        if (nav.length && !nav.hasClass('collections-sidebar')) {
            const sections = jQ('.category-grid-wrapper');
            const MainNavHeight = jQ('.main-header').outerHeight() + 20;
            jQ(window).on('scroll', function () {
                const curPos = jQ(this).scrollTop();
                sections.each(function () {

                    let top = jQ(this).offset().top - MainNavHeight;
                    if(jQ('.archive-sidebar-content-mobile').is(':visible')){
                        const sideHeight = jQ('.archive-sidebar-content-mobile').outerHeight();
                        top = top - sideHeight;
                    }
                    const bottom = top + jQ(this).outerHeight();
                    if (curPos >= top && curPos <= bottom) {
                        nav.find('a').removeClass('active');
                        sections.removeClass('active');
                        jQ(this).addClass('active');
                        nav.find('a[href="#' + jQ(this).attr('id') + '"]').addClass('active');

                        const path = window.location.href;
                        const loc = path.substr(path.indexOf("#") + 1);
                        const url = window.location.origin + window.location.pathname + '#' + jQ(this).attr('id');
                        if (loc !== jQ(this).attr('id') && window.location.href !== url) {
                            history.replaceState(null, null, url);
                        }
                    }
                });
                if (jQ('body.single-product').length){
                    const wrapper = jQ('[id*="product-"]');
                    const resetPoint = wrapper.offset().top + wrapper.height();
                    const url = window.location.origin + window.location.pathname;
                    if (curPos < resetPoint && window.location.href !== url){
                        history.replaceState(null, null, url);
                    }
                }
            });
        }
    }
    checkScroll() {
        const { nav, content, scrollContent } = this;
        if (content.height() < scrollContent.height()) {
            nav.addClass('has-scroll');
        } else {
            nav.removeClass('has-scroll');
        }
    }
}

export default new ArchiveSidebar();
